import * as React from 'react';

import {Shop} from 'interfaces';
import shopImages from '../../images';

export interface Props {
  shop: Shop;
}

const BANNER_WIDTH: number = 180;
const BANNER_HEIGHT: number = 136;

export default function ShopBanner(props: Props) {
  const {
    featured,
    sold,
    isContest,
  } = props.shop;

  if (featured) {
    return (
      <img
        width={BANNER_WIDTH}
        height={BANNER_HEIGHT}
        src={shopImages.featuredLarge}
        className="badge"
        alt=""
      />
    );
  } else if (sold) {
    return (
      <img
        width={BANNER_WIDTH}
        height={BANNER_HEIGHT}
        src={shopImages.soldLarge}
        className="badge"
        alt=""
      />
    );
  } else if (isContest) {
    return (
      <img
        src={shopImages.contestLarge}
        className="contest-badge"
        alt=""
      />
    );
  } else {
    return null;
  }
}
